/* CarbonPhone – GPSR-Angaben der App im Shop-Design gliedern (nur Darstellung, Inhalte bleiben unveraendert) */
(function () {
  var de = (document.documentElement.lang || 'de').toLowerCase().indexOf('de') === 0;
  var T = de
    ? { kicker: 'Produktsicherheit', title: 'Sicherheit & Herstellerangaben', sub: 'Pflichtangaben nach der EU-Produktsicherheitsverordnung (GPSR)', open: 'Alle aufklappen', close: 'Alle zuklappen' }
    : { kicker: 'Product safety', title: 'Safety & manufacturer details', sub: 'Mandatory information under the EU General Product Safety Regulation (GPSR)', open: 'Expand all', close: 'Collapse all' };
  var A = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var ICONS = {
    general: '<svg ' + A + '><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    manufacturer: '<svg ' + A + '><path d="M3 21V10l5 3V10l5 3V5h3l1 6h4v10z"/><path d="M7 17h2M12 17h2M17 17h1"/></svg>',
    responsible: '<svg ' + A + '><circle cx="12" cy="8" r="3.5"/><path d="M5 20c.8-3.6 3.6-5.5 7-5.5s6.2 1.9 7 5.5"/></svg>',
    safety: '<svg ' + A + '><path d="M12 3.5l9 16H3z"/><path d="M12 10v4.5"/><circle cx="12" cy="17.2" r=".7" fill="currentColor"/></svg>'
  };
  var KIND = { 'gpsr-general': 'general', 'gpsr-manufacturer': 'manufacturer', 'gpsr-responsible-person': 'responsible', 'gpsr-safety-info': 'safety' };

  function kv(p) {
    var first = p.firstChild;
    if (!first || first.nodeType !== 3) return;
    var t = first.textContent, i = t.indexOf(':');
    if (i < 1 || i > 40) return;
    var k = t.slice(0, i).trim(), rest = t.slice(i + 1).replace(/^\s+/, '');
    first.textContent = rest;
    var row = document.createElement('div');
    row.className = 'cp-gpsr__row';
    row.innerHTML = '<span class="cp-gpsr__k"></span>';
    row.firstChild.textContent = k;
    p.parentNode.insertBefore(row, p);
    p.classList.add('cp-gpsr__v');
    row.appendChild(p);
    // lange URLs als Domain anzeigen
    p.querySelectorAll('a[href^="http"]').forEach(function (a) {
      if (a.textContent.trim() === a.getAttribute('href')) {
        try { a.textContent = new URL(a.href).hostname.replace(/^www\./, '') + ' ↗'; } catch (e) {}
      }
    });
    var v = p.textContent.trim();
    if (/^(ja|yes)$/i.test(v)) p.innerHTML = '<span class="cp-gpsr__pill cp-gpsr__pill--ok">✓ ' + v + '</span>';
    else if (/^(nein|no)$/i.test(v)) p.innerHTML = '<span class="cp-gpsr__pill">' + v + '</span>';
  }

  /* Entsorgungstext (Zeilen mit "1." und "•") in Schritte gliedern */
  function disposal(p) {
    var lines = p.textContent.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    if (!lines.some(function (l) { return /^\d+\.\s/.test(l); })) return;
    var box = document.createElement('div');
    box.className = 'cp-gpsr__disp';
    var intro = [], steps = [], outro = [], cur = null;
    lines.forEach(function (l) {
      var m = l.match(/^\d+\.\s*(.*)$/);
      if (m) { cur = { title: m[1].replace(/:$/, ''), text: [], bullets: [] }; steps.push(cur); return; }
      if (!cur) { intro.push(l); return; }
      if (/^[•\-–]\s*/.test(l)) { cur.bullets.push(l.replace(/^[•\-–]\s*/, '')); return; }
      if (/^vielen dank|^thank you/i.test(l)) { outro.push(l); return; }
      cur.text.push(l);
    });
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
    var html = '';
    if (intro.length) html += '<p>' + intro.map(esc).join('<br>') + '</p>';
    html += '<ol class="cp-gpsr__steps">' + steps.map(function (s) {
      return '<li><strong>' + esc(s.title) + '</strong>' + s.text.map(esc).join(' ') +
        (s.bullets.length ? '<ul>' + s.bullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>' : '') + '</li>';
    }).join('') + '</ol>';
    if (outro.length) html += '<p>' + outro.map(esc).join(' ') + '</p>';
    box.innerHTML = html;
    p.replaceWith(box);
  }

  function enhance(w) {
    if (w.classList.contains('cp-gpsr')) return;
    w.classList.add('cp-gpsr');
    var sections = [].slice.call(w.querySelectorAll('.gpsr-section'));
    sections.forEach(function (s) {
      var kind = 'general';
      Object.keys(KIND).forEach(function (c) { if (s.classList.contains(c)) kind = KIND[c]; });
      var h = s.querySelector('.gpsr-section-title');
      if (h && !h.querySelector('.cp-gpsr__ico')) h.insertAdjacentHTML('afterbegin', '<span class="cp-gpsr__ico">' + ICONS[kind] + '</span>');
      if (h) { h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); h.click(); } }); }
      var c = s.querySelector('.gpsr-section-content');
      if (!c) return;
      [].slice.call(c.children).forEach(function (el) {
        if (el.tagName !== 'P') return;
        if (el.textContent.indexOf('\n') > -1 && el.textContent.length > 300) disposal(el);
        else kv(el);
      });
    });
    var head = document.createElement('div');
    head.className = 'cp-gpsr__head';
    head.innerHTML = '<div><p class="cp-gpsr__kicker"></p><h2 class="cp-gpsr__title"></h2><p class="cp-gpsr__sub"></p></div>' +
      (sections.length > 1 ? '<button type="button" class="cp-gpsr__toggle" aria-expanded="false"></button>' : '');
    head.querySelector('.cp-gpsr__kicker').textContent = T.kicker;
    head.querySelector('.cp-gpsr__title').textContent = T.title;
    head.querySelector('.cp-gpsr__sub').textContent = T.sub;
    w.insertBefore(head, w.firstChild);
    var btn = head.querySelector('.cp-gpsr__toggle');
    if (!btn) return;
    var sync = function () {
      var all = sections.every(function (s) { return s.classList.contains('active'); });
      btn.textContent = all ? T.close : T.open;
      btn.setAttribute('aria-expanded', all);
    };
    btn.addEventListener('click', function () {
      var open = !sections.every(function (s) { return s.classList.contains('active'); });
      sections.forEach(function (s) {
        s.classList.toggle('active', open);
        var h = s.querySelector('.gpsr-section-title');
        if (h) h.setAttribute('aria-expanded', open);
      });
      sync();
    });
    sections.forEach(function (s) { var h = s.querySelector('.gpsr-section-title'); if (h) h.addEventListener('click', function () { setTimeout(sync, 0); }); });
    sync();
  }

  function boot() { document.querySelectorAll('.shopify-app-block .gpsr-widget').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
})();
